/**
 * Created by luishenriques on 14/07/2017.
 */

/* globals EJS */

import i18n from './i18n';
import * as Utils from './utilityFunctions';

export default (function() {
  const renderView = {};
  let role;

  renderView.EJS = (view, params) => {
    const aux = {
      role,
    };
    aux.__ = i18n.__;
    aux.__n = i18n.__n;
    aux.__l = i18n.__l;
    aux.__h = i18n.__h;
    aux.__mf = i18n.__mf;
    aux.utils = Utils;
    aux.Utils = Utils;

    const dataRender = { ...aux, ...params };
    return new EJS({ url: view }).render(dataRender);
  };

  renderView.init = r => {
    role = r;
  };

  return renderView;
})();

if (typeof jQuery !== 'undefined') {
  jQuery.fn.insertAtIndex = function(index, element) {
    const lastIndex = this.children().size();
    if (index < 0) {
      index = Math.max(0, lastIndex + 1 + index);
    }
    this.append(element);
    if (index < lastIndex) {
      this.children()
        .eq(index)
        .before(this.children().last());
    }
    return this;
  };

  jQuery.fn.updateAtIndex = function(index, element) {
    const lastIndex = this.children().size();
    if (index < 0) {
      index = Math.max(0, lastIndex + 1 + index);
    }
    this.children()
      .eq(index)
      .remove();
    this.append(element);
    if (index < lastIndex) {
      this.children()
        .eq(index)
        .before(this.children().last());
    }
    return this;
  };
}
